var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowleft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 10 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.84561 8.5L9.64982 15.0295C10.1167 15.4803 10.1167 16.2112 9.64982 16.6619C9.1829 17.1127 8.42589 17.1127 7.95897 16.6619L0.350184 9.31619C-0.116728 8.86542 -0.116728 8.13458 0.350184 7.68381L7.95897 0.338077C8.42589 -0.112692 9.1829 -0.112692 9.64982 0.338078C10.1167 0.788849 10.1167 1.51969 9.64982 1.97046L2.84561 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowleft);
export default __webpack_public_path__ + "static/media/arrowleft.347cf0dd6cf080a6ebe7426146c47a44.svg";
export { ForwardRef as ReactComponent };